// @owners { team: patient-health }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, H2, LgPadding, MdSpacing, SmSpacing } from '@alto/design-system';
import { TransferForm } from '@alto/features';
import React from 'react';
import { ORIGIN_NAMES } from '~shared/lib/analytics/src/getOrigin';

export const TransferUpsellActionSheet = () => {
  return (
    <ActionSheetV2 analyticsName="transfer upsell">
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <H2>Transfer your prescriptions to Alto instantly. Tell us which pharmacy, we’ll do the rest.</H2>
        <MdSpacing />
        <Body>
          We can deliver all of your medications. Share your current pharmacy and the medications you would like
          transferred
        </Body>
        <MdSpacing />
        <SmSpacing />
        <TransferForm origin={ORIGIN_NAMES.TRANSFER_UPSELL} />
      </LgPadding>
    </ActionSheetV2>
  );
};
